import {useEffect} from "react";

export default function NotFound() {
    useEffect(() => {
        document.title = "Not Found - Hoarfroster";
    }, []);

    return (
        <div className="block px-16 min-h-32">
            <h1>You seems to enter the desert of knowledge.</h1>
            <p>WHAT THE HELL IS THE URL YOU TYPED IN?</p>
        </div>
    );
}